import React from 'react';
import IconName from "../../svgLogo/SvgLogo";

const SkeletonHomeSlider = () => {
    return (
        <div className="top-gallery-skeleton-wrapper">
            <div className="container-fluid">
                <div className="top-banner-sk skeleton-loading slow br-4"></div>
            </div>

            <div className="top-gallery xmt-4">
                <div className="container">
                    <div className="gallery-box br-4 xp-2">
                        <div className="row d-flex justify-content-center align-items-center">
                            <div className="col-4 xpx-10">
                                <div className="text--1-sk text-sk skeleton-loading"></div>
                                <div className="text--2-sk text-sk skeleton-loading xmt-2"></div>
                                <div className="text--3-sk text-sk skeleton-loading xmt-10"></div>
                                <div className="text--4-sk text-sk skeleton-loading xmt-2"></div>
                                <div className="button-sk skeleton-loading xmt-12 br-5"></div>
                            </div>
                            <div className="col-8">
                                <div className="image-box-sk skeleton-loading br-2"></div>
                            </div>
                        </div>
                    </div>
                    <div className="thumb-image-box d-flex align-items-center justify-content-between xmt-6 xpx-4">
                        <div className="next-arrow br-2 d-flex justify-content-center align-items-center">
                            <IconName name="chevron_right" className="icon"/>
                        </div>
                        <div className="images d-flex align-items-center">
                            <div className="thumb-sk skeleton-loading active"></div>
                            <div className="thumb-sk skeleton-loading"></div>
                            <div className="thumb-sk skeleton-loading"></div>
                            <div className="thumb-sk skeleton-loading"></div>
                            <div className="thumb-sk skeleton-loading"></div>
                            <div className="thumb-sk skeleton-loading"></div>
                            <div className="thumb-sk skeleton-loading"></div>
                            <div className="thumb-sk skeleton-loading"></div>
                            <div className="thumb-sk skeleton-loading"></div>
                            <div className="thumb-sk skeleton-loading"></div>
                            <div className="thumb-sk skeleton-loading"></div>
                            <div className="thumb-sk skeleton-loading"></div>
                            <div className="thumb-sk skeleton-loading"></div>
                            <div className="thumb-sk skeleton-loading"></div>
                            <div className="thumb-sk skeleton-loading"></div>
                        </div>
                        <div className="before-arrow br-2 d-flex justify-content-center align-items-center xmr-4">
                            <IconName name="chevron_left" className="icon"/>
                        </div>
                    </div>
                </div>
            </div>


        </div>
    );
};

export default SkeletonHomeSlider;
